/*
 * @Author: Witt
 * @Date: 2018-11-15 15:56:11
 * @Last Modified by: aalizzwell
 * @Last Modified time: 2019-07-09 16:23:04
 */

import { Injectable, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { RouterParamService } from '@farris/devkit';
import { FrameworkService, AppService } from '@gsp-sys/rtf-common';
import { MenuStateService } from './menu-state.service';
import { Subject } from 'rxjs';
import { LanguageService } from './languag.service';

// tslint:disable: no-string-literal
/**
 * è·¯ç±æå¡
 * @scope FormModule
 */
@Injectable()
class RouterService {
  /**
   * ä¸æ¬¡åæ¢çTabId
   */
  private lastSwitchId: string = null;
  /**
   * ä¸æ¬¡å³é­çTabId
   */
  private lastCloseId: string = null;
  // private menuStateService: MenuStateService = null;
  public onClosed: Subject<any> = null;
  constructor(
    private router: Router,
    private routerParamService: RouterParamService,
    private frameworkService: FrameworkService,
    @Optional() private appService: AppService,
    @Optional() private menuStateService: MenuStateService,
    @Optional() private languageService: LanguageService,
  ) {
    if (!this.menuStateService) {
      this.menuStateService = new MenuStateService();
    }
    if (!this.languageService) {
      this.languageService = LanguageService.getInstance();
    }
    this.onClosed = new Subject<any>();
    this.registerEvent();
  }

  /**
   * åæ¢è·¯ç±
   * @param url èåID
   * @param params è·¯ç±åæ°
   */
  public route(url: string, params: any) {
    url = this.router.createUrlTree([url]).toString();
    this.setParams(url, params);
    this.router.navigateByUrl(url);
  }
  /**
   * æ³¨åè¿è¡æ¡æ¶äºä»¶
   */
  public registerEvent() {
    const params: any = this.getParams(window.location.hash);
    const menuId = this.getAppId() || this.getFuncId();
    this.frameworkService.eventListner(this.frameworkService.FuncSwitch, e => {
      if (!e) {
        return;
      }
      const id = this.getOriginalId(e.id) || e.tabId;
      const menuState = this.menuStateService.getMenuState(id);
      if (!!id && menuId === id && !!menuState && menuState.length > 0) {
        this.formReload();
        this.lastSwitchId = id;
      }
    }, params);

    this.frameworkService.eventListner(this.frameworkService.FuncClosed, e => {
      if (!e) {
        return;
      }
      this.onClosed.next(e);
      const id = this.getOriginalId(e.id) || e.tabId;
      if (menuId === id) {
        return;
      }
      const menuState = this.menuStateService.getMenuState(menuId, id);
      // && id !== this.lastCloseId
      if (!!id && !!menuState && menuState.length > 0) {
        this.removeMenuState(id);
        this.formReload();
        this.lastCloseId = id;
      }
    }, params);
  }

  private removeMenuState(tabId: string) {
    if (this['context']) {
      this.menuStateService.removeMenu(tabId);
    }
  }
  /**
   * è·ååå§åè½id
   * @param id id
   */
  private getOriginalId(id: string) {
    if (!id) {
      return id;
    }
    if (id.indexOf('_') !== -1) {
      id = id.split('_')[0];
    }
    return id;
  }
  /**
   * å·æ°ç»ä»¶æ°æ®
   */
  private formReload() {
    try {
      this['context']['frameContext']['appContext']['refresh']();
    } catch{ }
  }
  /**
   * æå¼åè½èå
   * @param funcId èååç 
   * @param params è·¯ç±åæ°ï¼å½¢å¦ï¼ { key1: val1, key2: value2 }
   */
  public openMenu(funcId: string, params: any, reload?: boolean) {
    if (typeof reload === 'undefined' || typeof reload !== 'boolean') {
      reload = false;
    }
    const paramsMap = this.buildParamMap(params);
    const parentMenuId = this.getFuncId() || this.getAppId();
    this.menuStateService.addMenuState(parentMenuId, funcId);
    paramsMap.set('WEB_FORM_ROUTER_PARENT_ID', parentMenuId);
    this.frameworkService.openFuncWithParam(funcId, paramsMap, reload);
  }

  /**
   * æå¼åºç¨
   * @param appId åºç¨åç 
   * @param appEntrance åºç¨å¥å£
   * @param params è·¯ç±åæ°ï¼å½¢å¦ï¼ { key1: val1, key2: value2 }
   */
  public openApp(appId: string, appEntrance: string, params: any, reload?: boolean) {
    if (typeof reload === 'undefined' || typeof reload !== 'boolean') {
      reload = false;
    }
    const paramMap = this.buildParamMap(params);
    const parentMenuId = this.getAppId() || this.getFuncId();
    this.menuStateService.addMenuState(parentMenuId, appId);
    paramMap.set('WEB_FORM_ROUTER_PARENT_ID', parentMenuId);
    if (!!this.appService) {
      this.appService.openApp(appId, appEntrance, paramMap, reload);
    }
  }

  /**
   * æé åæ°
   */
  private buildParamMap(params: any): Map<string, string> {
    if (typeof params === 'undefined' || params === null || (typeof params === 'string' && params.length < 1)) {
      params = {};
    }
    const paramMap = new Map<string, any>();
    if (typeof params === 'object') {
      params = JSON.stringify(params);
    }
    params = window['encodeURIComponent'](params);
    paramMap.set('WEB_FORM_ROUTE_PARAMS', params);
    return paramMap;
  }

  /**
   * å³é­åè½èå
   */
  public closeMenu() {
    const funcId: string | null = this.getFuncId();
    const appId: string | null = this.getAppId();
    const { isDialogComponent, rootComponent } = this.findDialog();
    if (isDialogComponent) {
      const modalRef = this.get(rootComponent, 'dialogRef');
      modalRef['close']();
      return;
    }

    if (funcId !== null && typeof funcId === 'string' && funcId.length > 0) {
      this.closeFunc(funcId);
    } else if (appId !== null && typeof appId === 'string' && appId.length > 0) {
      const appEntrance = this.getAppEntrance();
      this.closeApp(appId, appEntrance);
    } else {
      console.error(this.languageService['notSupportMenuType']);
    }
  }

  /**
   * æ¥æ¾å¼¹çªç»ä»¶
   */
  private findDialog() {
    let frameContext = this.get(this, 'context.frameContext');
    let isDialogComponent = this.get(frameContext, 'frameComponent.isDialogRootComponent', false);

    let parentFrameContext = this.get(frameContext, 'parent');
    while (parentFrameContext != null && !isDialogComponent) {
      frameContext = this.get(frameContext, 'parent');
      parentFrameContext = this.get(parentFrameContext, 'parent');
      isDialogComponent = this.get(frameContext, 'frameComponent.isDialogRootComponent', false);
    }
    const rootComponent = this.get(frameContext, 'frameComponent');
    return { isDialogComponent, rootComponent };

  }

  /**
   * loadsh get
   * @param object å¯¹è±¡
   * @param path è·¯å¾
   * @param defaultVal é»è®¤å¼
   */
  private get(object: any, path: Array<string> | string, defaultVal: any = null) {
    const PATH = Array.isArray(path)
      ? path
      : path.split('.').filter(i => i.length);
    if (!PATH.length) {
      return object === undefined ? defaultVal : object;
    }

    if (object === null || object === undefined || typeof (object[PATH[0]]) === 'undefined') {
      return defaultVal;
    }

    return this.get(object[PATH.shift()], PATH, defaultVal);
  }

  /**
   * å³é­èå
   * @param funcId èåid
   */
  public closeFunc(funcId?: string) {
    if (!funcId) {
      funcId = this.getFuncId();
    }
    if (!!this.frameworkService) {
      this.frameworkService.closeFunc(funcId).subscribe();
    }
  }

  /**
   * å³é­app
   * @param appId åºç¨id
   */
  public closeApp(appId?: string, appEntrance?: string) {
    if (!appId) {
      appId = this.getAppId();
    }
    if (typeof appEntrance === 'undefined') {
      appEntrance = this.getAppEntrance();
    }
    if (!!this.appService) {
      this.appService.closeApp(appId, appEntrance).subscribe();
    }
  }

  /**
   * è®¾ç½®åæ°
   * @param params è·¯ç±åæ°
   */
  private setParams(url: string, params: string | { [key: string]: any; }) {
    let paramsObj;
    if (typeof params === 'string' && params !== '') {
      paramsObj = JSON.parse(params);
    } else {
      paramsObj = params || {};
    }

    // è®¾ç½®è·¯ç±åæ°
    this.routerParamService.setParams(url, paramsObj);
  }

  /**
   * è·åfuncId
   */
  private getFuncId() {
    const hash = window.location.hash;
    if (!hash) {
      return null;
    }
    const params = this.decodeURLParams(hash);
    if (params && params.hasOwnProperty('funcId')) {
      return params.funcId;
    } else {
      return null;
    }
  }

  /**
   * è·åappId
   */
  private getAppId() {
    const hash = window.location.hash;
    if (!hash) {
      return null;
    }
    const params = this.decodeURLParams(hash);
    if (params && params.hasOwnProperty('appId')) {
      return params.appId;
    } else {
      return null;
    }
  }

  private getParentMenuId() {
    const hash = window.location.hash;
    if (!hash) {
      return null;
    }
    const params = this.decodeURLParams(hash);
    if (params && params.hasOwnProperty('WEB_FORM_ROUTER_PARENT_ID')) {
      return params.WEB_FORM_ROUTER_PARENT_ID;
    } else {
      return null;
    }
  }
  /**
   * è·ååºç¨å¥å£
   */
  private getAppEntrance() {
    const hash = window.location.hash;
    if (!hash) {
      return null;
    }
    const params = this.decodeURLParams(hash);
    if (params && params.hasOwnProperty('appEntrance')) {
      return params.appEntrance;
    } else {
      return null;
    }
  }
  /**
   * è§£ç åæ°
   * @param query search|hash
   */
  private decodeURLParams(query: string): { [propName: string]: any } {
    if (typeof query === 'undefined') {
      query = window.location.hash || window.location.search;
    }
    const hashes = query.slice(query.indexOf('?') + 1).split('&');
    return hashes.reduce((params, hash) => {
      const split = hash.indexOf('=');
      const key = hash.slice(0, split);
      const val = hash.slice(split + 1);
      return Object.assign(params, { [key]: decodeURIComponent(val) });
    }, {});
  }
  private getParams(queryString: string): { [propName: string]: any } {
    if (!queryString) {
      return {};
    }
    const hashes = queryString.slice(queryString.indexOf('?') + 1).split('&');
    return hashes.reduce((params, hash) => {
      const split = hash.indexOf('=');
      const key = hash.slice(0, split);
      const val = hash.slice(split + 1);
      return Object.assign(params, { [key]: decodeURIComponent(val) });
    }, {});
  }
}

export { RouterService };
